import { z } from "zod";

// Request body schema
export const suggestNodeBodySchema = z.object({
  nodes: z.array(z.any()),
  edges: z.array(z.any()),
  canvas: z.any(),
  sourceNodeId: z.string().optional(),
});

// Type inference
export type SuggestNodeBody = z.infer<typeof suggestNodeBodySchema>;

export async function suggestNodeStream({
  nodes,
  edges,
  canvas,
  sourceNodeId,
}: SuggestNodeBody): Promise<ReadableStream> {
  const predictionInput = {
    nodes,
    edges,
    canvas,
    sourceNodeId,
  };

  const response = await fetch("/api/zsl/canvas/recommend_asset", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(predictionInput),
  });

  if (!response.ok) {
    throw new Error("Failed to fetch recommendation stream");
  }

  return response.body!;
}
